import React from 'react';
import { Chip } from '@mui/material';
import { SaleType, SALE_TYPE_LABELS, SALE_TYPE_COLORS } from '../types';

interface SaleBadgeProps {
  saleType: SaleType | 'all';
  size?: 'small' | 'medium';
  onClick?: () => void;
}

const SaleBadge: React.FC<SaleBadgeProps> = ({ 
  saleType, 
  size = 'small',
  onClick 
}) => {
  if (saleType === 'all') {
    return (
      <Chip
        label="All"
        size={size}
        onClick={onClick}
        sx={{
          bgcolor: 'grey.200',
          color: 'text.primary',
          fontWeight: 600,
          '&:hover': {
            bgcolor: 'grey.300',
          },
        }}
      />
    );
  }

  const backgroundColor = SALE_TYPE_COLORS[saleType] || '#15803d';
  
  return (
    <Chip
      label={SALE_TYPE_LABELS[saleType] || saleType}
      size={size}
      onClick={onClick}
      sx={{
        backgroundColor,
        color: '#ffffff',
        fontWeight: 600,
        fontSize: size === 'small' ? '0.7rem' : '0.8rem',
        '&:hover': {
          backgroundColor,
          filter: 'brightness(0.9)',
        },
      }}
    />
  );
};

export default SaleBadge;
